// typescript
'use client';

import * as React from 'react';
import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';
import { Box } from '@mui/material';
import UKFlag from '@/components/ui/icons/BrittishFlag';
import SwedishFlag from '@/components/ui/icons/SwedishFlag';

const LOCALES = ['sv', 'en'];

const resolveFlagIcon = (locale: string, flagSize?: number) => {
  switch (locale) {
    case 'sv':
      return <SwedishFlag size={flagSize}/>;
    case 'en':
      return <UKFlag size={flagSize} />;
    default:
      return <SwedishFlag size={flagSize} />;
  }
};

type LanguageSwitcherProps = {
  flagSize?: number;
}

export function LanguageSwitcher({flagSize}: LanguageSwitcherProps) {
  const pathname = usePathname() || '/';
  const searchParams = useSearchParams();
  const query = searchParams ? `?${searchParams.toString()}` : '';

  const parts = pathname.split('/').filter(Boolean);
  const currentLocale = LOCALES.includes(parts[0]) ? parts[0] : 'sv';

  const targetLocale = currentLocale === 'sv' ? 'en' : 'sv';

  function hrefWithLocale(locale: string) {
    const parts = pathname.split('/').filter(Boolean);
    if (parts.length > 0 && LOCALES.includes(parts[0])) {
      parts[0] = locale;
      return `/${parts.join('/')}${query}`;
    }
    if (pathname === '/') return `/${locale}${query}`;
    return `/${locale}${pathname}${query}`;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Link
        href={hrefWithLocale(targetLocale)}
        aria-label={targetLocale === 'en' ? 'Switch to English' : 'Switch to Swedish'}
        title={targetLocale === 'en' ? 'Switch to English' : 'Switch to Swedish'}
        style={{ display: 'inline-flex', alignItems: 'center' }}
      >
        {resolveFlagIcon(targetLocale, flagSize)}
      </Link>
    </Box>
  );
}
